/* eslint-disable import/prefer-default-export */

// This function gets called a lot, so it's best to not create a new
// object on every call
const emptyObject = {};
export const normObject = <Props extends Record<string, unknown>>(
	condition: unknown,
	obj: Props,
): Props | Record<string, never> => (condition ? obj : emptyObject);
